import { html } from 'lit-html';
import { CarouselItem } from '../../../models/item';
import { getSiteTypeValue } from '../../../models/js_env';
import { ItemLink } from './price_image_link';
import { AnalyticsItem } from '../../../models/analytics/analytics_item';

export const ButtonArea = (carouselItem: CarouselItem) => {
  if (carouselItem.isVariation) {
    return VariationButton(carouselItem);
  } else {
    return AddCartButton(carouselItem);
  }
};

const VariationButton = (carouselItem) => html`
  <div class="m-itemcard_variationButton">
    <a
      href=${ItemLink(
        carouselItem.supplierId,
        carouselItem.itemCode,
        carouselItem.isVariation,
        carouselItem.rrLinkUrl
      )}
      class="m-btn -small -tertiary"
    >
      <span class="m-btn_inner">
        <span class="m-btn_text">バリエーション</span>
      </span>
    </a>
  </div>
`;

const AddCartButton = (carouselItem: CarouselItem) => html`
  <div class="m-itemcard_cart">
    <div class="m-addcart js-addcart">
      <div class="m-addcart_input">
        <div class="m-addcart_pulldown">
          <div class="a-pulldown js-lazy-img -size48">
            <span class="a-pulldown_select">
              <select title="数量">
                <option value="1" selected="">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10+</option>
              </select>
            </span>
          </div>
        </div>
        <div class="m-addcart_textinput u-dn-all">
          <div class="a-textinput -small -size48 js-input">
            <span class="a-textinput_inputwrap">
              <input
                type="number"
                class="a-textinput_input"
                min="1"
                max="999"
                title="数量"
                value="1"
              />
            </span>
          </div>
        </div>
      </div>
      <div>
        <button
          class="m-btn -primary -small"
          type="button"
          data-supplier-id="${carouselItem.supplierId}"
          data-catalog-item-code="${carouselItem.itemCode}"
          data-site-type-value="${getSiteTypeValue()}"
          data-medical-material-type="${new AnalyticsItem()._medicalMaterialType}"
          onclick="TRYLION.Env.FUNCTIONS.clickAddCart(this)"
        >
          <span class="m-btn_inner">
            <span class="m-btn_text">カゴへ</span>
          </span>
        </button>
      </div>
    </div>
  </div>
`;
